import { createI18n } from 'vue-i18n'
import store from '../../store'
import { getBotConstantTranslations, getBotJsonTranslations } from '../CDN_fetchConfig'
import { getJsonTemplate } from './jsonConfigTemplateBuilder'
import translations from './languages/bot_en'

class I18n {
constructor(options = {locale: 'en', fallbackLocale: 'en', messages: translations, silentTranslationWarn: true}) {
        this.options = options
        this.i18n = this.setupI18n()
        this.setI18nLanguage(this.options.locale)
    }

    setupI18n() {
        // setting up i18n instance with options object.
        const i18n = createI18n({
            ...this.options,
            legacy: true,
            globalInjection: true
        })
        return i18n
    }

    setI18nLanguage(locale) {
        this.i18n.global.locale = locale 
    }

    setLocaleMessages(localeMessages) {
        const locale = Object.keys(localeMessages)[0]
        let translation = localeMessages[locale]

        this.setI18nLanguage(locale)
        const messages = this.i18n.global.messages
        translation = !messages[locale] ? translation : {...messages[locale], ...translation}       
        this.i18n.global.setLocaleMessage(locale, translation)
    }

    async loadBotConstantLocaleMessages(lang_code) {
        /* 
            This function is used for setting up the bot's constant translation strings.
            since english constant strings are present inside the codebase itself, we won't be hitting any API call for fetching the
            english translation else for any other language, translations will be fetched. 
        */
        let localeMessages = lang_code && (lang_code === 'en' ? translations : await getBotConstantTranslations(lang_code))
        if(localeMessages) {
            this.setLocaleMessages(localeMessages)
        }
    }

    async loadBotJsonConfigLocaleMessages(lang_code = 'en') {
        let jsonConfigLocaleMessages = lang_code && (lang_code === 'en' ? getJsonTemplate(store.state.widgetConfig) : await getBotJsonTranslations(lang_code))
        if(jsonConfigLocaleMessages) {
            this.setLocaleMessages(jsonConfigLocaleMessages)
        }
    }

    async updateLocaleAndMessages(locale) {
        if(this.i18n.global.locale !== locale) {
            await Promise.all([this.loadBotJsonConfigLocaleMessages(locale), this.loadBotConstantLocaleMessages(locale)])
        }
    }

    // Add a method to get translation
    t(key, ...args) {
        return this.i18n.global.t(key, ...args)
    }
    
    // Expose locale getter
    get locale() {
        return this.i18n.global.locale
    }

}

export default new I18n()
